module.exports = __webpack_public_path__ + "static/media/logo.5ff40151.png";